export default "__VITE_ASSET__843b6971__"